import React, { useEffect, useState } from 'react';
import GenericModal from '../../components/agv-generic-modal';
import InputText from '../../components/agv-forms-input';

export default function CreatePhoneNumberModal({
  isOpen,
  setIsOpen,
  createPhoneNumber,
  mainActionIsLoading,
}) {
  const [title, setTitle] = useState('');
  const [phone_number, setPhoneNumber] = useState('');

  const DISABLED = !title.length || !phone_number.length;

  useEffect(() => {
    if (!isOpen) {
      setTitle('');
      setPhoneNumber('');
    }
  }, [isOpen]);

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Ajouter un numéro de téléphone'}
      mainAction={() => createPhoneNumber(title.trim(), phone_number.trim())}
      mainActionText={'Créer'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={DISABLED}
    >
      <div className="tw-flex tw-flex-col tw-pb-6">
        <InputText
          value={title}
          setValue={setTitle}
          fieldTitle={'Titre'}
          isRequired
          emptyError={`Le champ "Titre" ne peut être vide.`}
          style={'tw-mt-6'}
          placeholder={'Support technique, Urgences, etc.'}
        />
        <InputText
          value={phone_number}
          setValue={setPhoneNumber}
          fieldTitle={'Numéro de téléphone'}
          isRequired
          emptyError={`Le champ "Numéro de téléphone" ne peut être vide.`}
          style={'tw-mt-6'}
          placeholder={'01 23 45 67 89'}
          type="tel"
        />
      </div>
    </GenericModal>
  );
}
